

function preparePlaylist(playerInstance, list, showImages) {
  playerInstance.on('ready', function () {
    const playlist = playerInstance.getPlaylist();
    list.parent().height(list.parent().siblings('.jwplayer').height());
    let html = '';
    for (let index = 0; index < playlist.length; index++) {
      const playindex = index + 1;
      if (list.children(`#VideoNo${index}`).length == 0) {
        html += `<li id='VideoNo${index}'`;

        // console.log(`${index} ${showImages}`);
        if (showImages) {
          html += ' style="padding: 10px;"';
        }
        html += `><span title='${playlist[index].title}'><a onclick='window.playThis(${index},${playerInstance.id}); return false;' href=''>`;
        if (playlist[index].image != null && !showImages) {
          html += `<img class='VideoThumb' height='70' width='120' src='${playlist[index].image}'<\/img> `;
        }
        html += `${playlist[index].title}</a></span></li>`;
      }
    }

    list.append(html);
  });


  playerInstance.on('playlistItem', function () {
    list.children('.VideoCurrent').removeClass('VideoCurrent');
    list.children().eq(playerInstance.getPlaylistIndex()).addClass('VideoCurrent');
  });
}
function playThis(index, playerInstance) {
  playerInstance.playlistItem(index);
}

function checkPlaylistDisplay() {
  let currentSheet = null;

  $(document.styleSheets).each(function (sheetIndex) {
    currentSheet = document.styleSheets[sheetIndex];
    $(currentSheet.cssRules).each(function (ruleIndex) {
      if (currentSheet.cssRules[ruleIndex].selectorText && currentSheet.cssRules[ruleIndex].selectorText.indexOf('VideoList') >= 0) {
        return true;
      }
    });
  });

  return false;
}
window.preparePlaylist = preparePlaylist;
window.playThis = playThis;
window.checkPlaylistDisplay = checkPlaylistDisplay;



// WEBPACK FOOTER //
// Glasshouse/Core/js/playlist.js